import React from 'react';
import {WithTranslation, withTranslation} from 'react-i18next';
import {HostApiProps, withHostApi} from "../contexts/HostApiContext";
import ShopRepository from "../repositories/shop/ShopRepository";
import Modal from "react-responsive-modal";
import IconsSocial from "./IconsSocial";
import {youtubePlaylist} from "./iYoutubePlaylist";

interface VideoPropsInit {
  tag: string,
  onlyModale: boolean,
  fullWidth: boolean,
  allVideos?: youtubePlaylist;
}
type VideoProps = VideoPropsInit & WithTranslation & HostApiProps;

interface VideoState {
  allVideos?: youtubePlaylist;
  openVideo: boolean;
  videoOpenId: string;
}

class Video extends React.Component<VideoProps, VideoState> {
  constructor(props: any) {
    super(props);
    this.state = {
      allVideos: undefined,
      openVideo : false,
      videoOpenId: ''
    }
  }

  componentDidMount() {
    if(this.props.allVideos && this.props.allVideos?.playlists) {
      this.setState({allVideos: this.tagFilter(this.props.allVideos)});
    } else {
      const shopRepository = new ShopRepository();
      shopRepository.fetchVideos(this.props.hostApi).then((res) => {
        this.setState({allVideos: this.tagFilter(res)});
      }).catch((err) => {
        console.error(err);
      });
    }
  }

  private tagFilter(videos: any) {
    const videosFiltered : any[] = [];
    if(videos?.playlists && videos.playlists.length > 0 ) {
      for(const playlist of videos.playlists){
        for(const videoIndex in playlist.videos) {
          const video = playlist.videos[videoIndex];
            for (const tagIndex in video.snippet?.tags) {
              const tag = video.snippet.tags[tagIndex];
               if (tag && tag.toLowerCase() === this.props.tag.toLowerCase() && !videosFiltered.includes(video)) {
                videosFiltered.push(video);
              }
            }
        }
      }
    }
    return videosFiltered;
  }
  onOpenModalVideo = (videoId: string) => {
    if (!this.state.openVideo) { this.setState({openVideo: true,videoOpenId : videoId}); }
  }
  onCloseModalVideo = () => {
    if (this.state.openVideo) { this.setState({openVideo: false, videoOpenId: ''}); }
  }

  render() {
    const videoRender  = () => {
      const htmlVideo : any[] = [];

      if (this.state.allVideos) {
        for (const item of this.state.allVideos) {
          if(item && item.id) {
            if (this.props.onlyModale) {
              htmlVideo.push(
                <div
                  className={" cursor-pointer red d-flex align-items-center "}
                  onClick={() => this.onOpenModalVideo(item.id)}>
                  <IconsSocial icon="youtube" className={'red mr-2'}/>{this.props.t('watch_the_video')}
                </div>
              )
            } else {
              htmlVideo.push(
                <div className={"embed-responsive embed-responsive-16by9"}>
                  <iframe className={"embed-responsive-item"}
                          src={`https://www.youtube-nocookie.com/embed/${item.id}?controls=1&rel=0&showinfo=0&modestbranding=1&iv_load_policy=3`}
                          frameBorder="0"
                          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen></iframe>
                </div>
              )
            }
          }
        }
        return htmlVideo;
      }
    }

    if(this.state.allVideos) {
      return (
        <>
          {videoRender()}
          {this.state.videoOpenId !== '' &&
            <Modal open={this.state.openVideo} onClose={this.onCloseModalVideo} classNames={{modal: "zoomVideo"}}
                   center>
              <div className={"embed-responsive embed-responsive-16by9"}>
                <iframe className={"embed-responsive-item"}
                        src={`https://www.youtube-nocookie.com/embed/${this.state.videoOpenId}?controls=1&autoplay=1&rel=0&showinfo=0&modestbranding=1&iv_load_policy=3`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen></iframe>
              </div>
            </Modal>
          }
       </>
      );
    } else {
      return null;
    }
  }
}
export default withTranslation('common')(withHostApi(Video));
